import axios from 'axios';
import { API_URL } from 'lib/network/api';

export const getImageUrl = async (imagePath) => {
  try {
    if (!imagePath) {
      return '/kin/assest/image/icon-profile.png';
    }

    const cacheBuster = new Date().getTime();
    const res = await axios.get(`${API_URL}/file?file_path=${imagePath}&_=${cacheBuster}`, {
      responseType: 'arraybuffer',
    });

    // Pastikan response berupa gambar
    if (!res.headers['content-type'].startsWith('image')) {
      throw new Error('Invalid content type');
    }

    const arrayBufferView = new Uint8Array(res.data);
    const blob = new Blob([arrayBufferView], { type: res.headers['content-type'] });
    const imageUrl = URL.createObjectURL(blob);

    return imageUrl;
  } catch (error) {
    console.error('Error fetching image:', error);
    return '/kin/assest/image/icon-profile.png';
  }
};
